/* eslint-disable eqeqeq */
import { getNowDateTime } from '__utils/date';
import { getNetworkType } from '__utils/getNetwork';
import { getRequestId } from 'emrn-api/getRequestId';
import { Container } from 'emrn-hybrid/Container';
import { Passport } from 'emrn-hybrid/Passport';
import { selectPlatform } from 'emrn-hybrid/selectPlatform';
import { Platform } from 'react-native';
import { BaseRequest, BcBaseRequest } from '../shared';

/**
 * 组装大赛接口请求参数
 * @author chenyongbin <yongbin@eastmoney.com>
 * @param paramst 请求参数
 */
export async function getDsbcApiRequest(params: object, needLogin: boolean = true) {
  let _data: BcBaseRequest = {
    ARGS: {},
    CLIENT: Platform.OS == 'web' ? 'web' : selectPlatform({ ios: 'Iphone', android: 'Android' }), //客户端类型，ios/android/web ,
    DEVICE: '', //机器型号 ,
    NET: Platform.OS == 'web' ? getNetworkType() : '', //网络，WIFI/流量/VPN ,
    PRODUCT: '', //包类型，东方财富/股吧 ,
    REQUESTID: '', //客户端随机流水ID ,
    RESERVE: '', //预留字段，可供特殊接口留底 ,
    TIME: getNowDateTime(), //客户端时间 ,
    VERSION: '', //客户端版本
  };

  //请求id
  const requestId = getRequestId(new Date(), 32);
  _data.REQUESTID = requestId;

  let baseParams: BaseRequest = {};

  const [{ info: passport }, device, app] = await Promise.all([
    Passport.getUserInfo(),
    Container.getDeviceInfo(),
    Container.getApplicationInfo(),
  ]);

  // 通行证ID
  if (passport && needLogin) {
    baseParams.ctToken = passport.cToken;
    baseParams.utToken = passport.uToken;
  }

  // app信息
  if (app && Platform.OS !== 'web') {
    _data.VERSION = app.appVersionCode || '';
    if (app.appType == 'gb') {
      _data.PRODUCT = 'Guba';
    } else {
      _data.PRODUCT = 'EastMoney';
    }
  } else {
    _data.VERSION = '0';
    _data.PRODUCT = 'web';
  }

  // 设备信息
  if (device && Platform.OS !== 'web') {
    _data.DEVICE = `${device.model} -- ${device.osv}`;
    _data.NET = `${device.network} -- ${device.carrier}`;
  } else {
    _data.DEVICE = '0';
  }

  _data.ARGS = Object.assign({}, baseParams, params);
  return _data;
}
